import { AbstractControl } from "@angular/forms";

export function mortProviderValidator(control: AbstractControl) {
    let curValue = control.value.toLowerCase();
    let listOfValues = ['CIBC', 'Sutton', 'Sutton', 'First Line'];
    let lowercasedArray = listOfValues.map(str => str.toLowerCase());
    let errorFound = false;
    if (lowercasedArray.indexOf(curValue) > -1) {
        errorFound = true
    } else if (!errorFound) {
        lowercasedArray.forEach(obj => {
            errorFound = (!errorFound) ? curValue.startsWith(obj) : errorFound
        })
    }
    return (errorFound) ? { mortProviderInvalid: true } : null;
}
